import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { IdentityService } from '../../identity.service';
import { Router } from '@angular/router';
import { UIControlService } from 'src/app/shared/uicontrol.service';

@Component({
  selector: 'app-phone-login',
  templateUrl: './phone-login.component.html',
  styleUrls: ['./phone-login.component.scss']
})
export class PhoneLoginComponent implements OnInit {
  constructor(
    public identityService: IdentityService,
    private fireAuth: AngularFireAuth,
    private formBuilder: FormBuilder,
    private ui: UIControlService,
    private router: Router
  ) {}

  public form: FormGroup;
  public confirmationForm: FormGroup;
  public destroyed = new Subject();
  public confirmationResult;
  public loading = false;

  get displayName(): string {
    return this.form.value.displayName.toString().trim();
  }

  get internationalizedPhoneNumber(): string {
    if (this.form.value?.phoneNumber === null) {
      return '';
    }

    const rawNumber: string = this.form.value.phoneNumber.toString().trim();
    let internationalizedPhoneNumber = rawNumber;

    if (rawNumber.charAt(0) === '0') {
      internationalizedPhoneNumber = internationalizedPhoneNumber.slice(1);
    }

    internationalizedPhoneNumber = '+27' + internationalizedPhoneNumber;
    return internationalizedPhoneNumber;
  }

  public ngOnInit(): void {
    this.form = this.formBuilder.group({
      phoneNumber: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{9,10}$')]
      ]
    });

    this.confirmationForm = this.formBuilder.group({
      confirmationCode: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{6}$')]
      ]
    });

    this.fireAuth.user.subscribe(user => {
      if (user != null) {
        this.ui.notifySuccess(`Logged in!`);
      }
    });
  }

  public async signUp() {
    if (this.form.valid) {
      this.loading = true;
      try {
        this.confirmationResult = await this.identityService.signInWithPhoneNumber(
          this.internationalizedPhoneNumber
        );
        this.loading = false;
      } catch (error) {
        this.ui.notifyFailure('Something went wrong');
      }
    } else {
      this.ui.notifyFailure('Please correct your details.');
    }
  }

  public async confirm() {
    if (this.form.valid) {
      this.loading = true;
      this.identityService
        .confirmPhoneNumber(
          this.confirmationResult,
          this.confirmationForm.value.confirmationCode
        )
        .then(result => {
          if (result === false) {
            this.ui.notifyFailure(
              'The entered confirmation code is invalid, please try again.'
            );

            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(['login/phone']);
          } else {
            this.identityService.handleAuthenticationReroute();
          }
        })
        .catch(error => {
          console.error(error);
          this.ui.notifyFailure('Something went wrong.');
        });
    }
  }
}
